/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import {
  getEnergyUsageColumnsForNILM,
  getMeterWiseAggregationsForNILM
} from '../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import { IEnergyMetersData } from '../../../shared/Utils/ICarbonViewDetailsUtils';
import { IDataTableColumn } from '../../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import EmaasDetailBreakdownByMeter from './EmaasDetailBreakdownByMeter';
import { IEnergyData } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import {
  IEnergyBreakdownByMeter,
  flatArry
} from './IEnergyUsagesBreakdownProps';
import { ApiContext } from '../../../../context/ApiContext';

interface ITotalEmissionsSavingsByMeterDetailComponentProps {
  data: IEnergyData;
}

export const flattenEnergyUsageByDisaggregationArray = (
  arr: Array<flatArry> | undefined,
  flat: Array<flatArry>
) => {
  arr &&
    arr.forEach((ar: flatArry) => {
      flat.push(ar);
      if (ar.disaggregation && ar.disaggregation.length > 0) {
        flattenEnergyUsageByDisaggregationArray(ar.disaggregation, flat);
      }
    });
  return flat;
};

export const EmaasEnergyUsagesAllUtilitySavingsByMeterDetailNILM = (
  props: ITotalEmissionsSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const { data } = props;

  const apiContext = useContext(ApiContext);
  const { userPreferedUnit } = apiContext;

  let fromUnit;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }

  fromUnit = userPreferedUnit as any;

  const flatMeterWiseAggregations = data.nilmAggregation
    ? flattenEnergyUsageByDisaggregationArray(
        data.nilmAggregation.meterWiseAggregation,
        []
      )
    : [];
  const { energyMeasurementUnit } = data;

  const columnDetails: Array<IDataTableColumn> = getEnergyUsageColumnsForNILM(
    t
  );
  const newMeterData: {
    data: IEnergyMetersData[];
    unit: string;
  } = getMeterWiseAggregationsForNILM(
    data.nilmAggregation && data.nilmAggregation.meterWiseAggregation,
    fromUnit, //energyMeasurementUnit,
    flatMeterWiseAggregations,
    energyMeasurementUnit,
    apiContext.showChangeWhenData
  );

  const breakDownByMeterProps = {
    meterData: newMeterData.data,
    utilityMeasurementUnit: newMeterData.unit,
    columnDetails,
    isNILM: true,
    energyMeasurementUnit: energyMeasurementUnit
  } as IEnergyBreakdownByMeter;

  return (
    <div className="emaas-Metersaving-details-head-NILM">
      <EmaasDetailBreakdownByMeter {...breakDownByMeterProps} />
    </div>
  );
};
export default memo(EmaasEnergyUsagesAllUtilitySavingsByMeterDetailNILM);
